<template>
  <div class="broadcast-ticket-list">
    <transition-group :name="firstRender ? '' : 'ticket-transition'" tag="div">
      <ticket-item
        v-for="ticket in tickets"
        :key="ticket.id"
        :ticket="ticket"
        :removeable="removeable"
        :type="type"
      />
    </transition-group>
    <div v-if="tickets.length === 0 && emptyList" class="page-placeholder-text p-a-4 ta-c">
      <p>{{ emptyList }}</p>
    </div>
  </div>
</template>

<script>

import TicketItem from './TicketItem.vue';

export default {
  components: {
    TicketItem,
  },
  props: {
    removeable: {
      type: Boolean,
      default: true,
    },
    selector: {
      type: String,
      default: '',
    },
    emptyList: {
      type: String,
      default: '',
    },
    type: {
      type: String,
      default: 'broadcast',
      validator: value => ['broadcast', 'video'].indexOf(value) !== -1,
    },
  },
  computed: {
    tickets() {
      const {
        selector,
      } = this;
      return this.$store.getters['Products/allStreams'].filter((ticket) => {
        if (ticket.access.content.includes(selector)) {
          return ticket;
        }

        return null;
      });
    },
  },
  data() {
    return {
      firstRender: true,
    };
  },
  mounted() {
    this.$nextTick(() => {
      this.firstRender = false;
    });
  },
};
</script>

<style lang="scss" scoped>
.ticket-transition-move {
  transition: transform 0.5s ease;
}
.ticket-transition-enter-active, .ticket-transition-leave-active {
  transition: opacity 1s, transform 1s;
}
.ticket-transition-enter, .ticket-transition-leave-to {
  opacity: 0;
  transform: translateX(-100px);
}
</style>
